import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useMutation, useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getDDCSubjects, getFootPrint, getLibraryfineRegister } from '../../NecttosComp/APICaller/ApiServices';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input from '../../NecttosComp/Input/Input';
import Button from '../../NecttosComp/Button/Button';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const FineRegister = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);

	const { data = [], isFetching, refetch } = useQuery('getLibraryfineRegister', getLibraryfineRegister(collegeId));
	const [isLoading, setIsLoading] = useState(false);

	const [admisionNumber, setAdmisionNumber] = useState('');
	const [searchTerm, setSearchTerm] = useState('');

	const manageDDCSubject = useCallback(async () => {
		try {
			setIsLoading(true);
			console.log({ admisionNumber });
			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postFootPrint', {
				collegeId,
				admisionNo: admisionNumber,
				method: 'offline',
				type: 'internal',
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setAdmisionNumber('');
				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	}, [admisionNumber]);

	useEffect(() => {
		const listener = (event) => {
			if (event.code === 'Enter' || event.code === 'NumpadEnter') {
				event.preventDefault();
				manageDDCSubject();
			}
		};
		document.addEventListener('keydown', listener);
		return () => {
			document.removeEventListener('keydown', listener);
		};
	}, [manageDDCSubject]);
	const filteredData = data?.filter((item) => {
		const classDept = String(item?.classDept || '').toLowerCase();
		const name = String(item?.name || '').toLowerCase();
		const admn = String(item?.admisionNo || '').toLowerCase();
		const search = searchTerm.toLowerCase();

		return classDept.includes(search) || name.includes(search) || admn.includes(search);
	});

	return (
		<Main height='100%' width='100%' title='Fine Register'>
			<Header>
				<div className='flex'>
					<Input width='400px' fieldName='Search by Name,Class & Admission Number' state={searchTerm} setState={setSearchTerm} type='text' />
				</div>
				<div className='flex'>
					<Button
						type='fetch'
						onClick={() => {
							refetch();
						}}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
						<Instruction keyId={'fineRegister'}/>
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>
			<Body>
				<div ref={componentRef} className='printable bg-gray-100 dark:bg-gray-600 print:bg-white print:text-black rounded-lg overflow-x-auto'>
					<img className='absolute top-[55%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50%] h-[60vh] pointer-events-none z-0 print:hidden' style={{ opacity: 0.09 }} alt='watermark' src={selectedCollege?.logo} />

					<div className='flex items-center justify-between w-full mb-4'>
						<h5 className='text-[30px] font-semibold text-slate-700 ml-6 mt-5 dark:text-neutral-100 '>Fine Register</h5>
						<img className='hidden print:block w-[120px] h-auto' alt='college logo' src={selectedCollege?.logo} />
					</div>

					<div className='min-w-[900px]'>
						<Table width='100%' innerWidth={['5%', '15%', '25%', '20%', '10%', '10%', '8%', '10%', '20%']}>
							<Thead>
								<Tr>
									<Th position={0} textAlign='center'>
										Sn
									</Th>
									<Th position={1}>Admn No</Th>
									<Th position={2}>Name</Th>
									<Th position={3}>Class/Dept</Th>
									<Th position={4}>Date</Th>
									<Th position={5} textAlign='center'>
										Books
									</Th>
									<Th position={6} textAlign='center'>
										Fine
									</Th>
									<Th position={7}>Receipt</Th>
									<Th position={8}>Date of Remittance</Th>
								</Tr>
							</Thead>
							<Tbody height='65vh'>
								{filteredData?.map((item, i) => (
									<Tr key={i} index={i}>
										<Td index={i} position={0} textAlign='center'>
											{i + 1}
										</Td>
										<Td index={i} position={1}>
											{item.admisionNo}
										</Td>
										<Td index={i} position={2}>
											{item.name}
										</Td>
										<Td index={i} position={3}>
											{item.classDept}
										</Td>
										<Td index={i} position={4}>
											{item.date}
										</Td>
										<Td index={i} position={5} textAlign='center'>
											{item.totalBooks}
										</Td>
										<Td index={i} position={6} textAlign='center'>
											{item.balanceFine}
										</Td>
										<Td index={i} position={7}>
											{item.billNo}
										</Td>
										<Td index={i} position={8}>
											{item.dateOfRemitence}
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</div>
				</div>
			</Body>
			 
		</Main>
	);
};
